// A Exercises komponens a gyakorlatok listáját jeleníti meg, elöször csak 10-et, az API hivások számának optimalizálása érdekében, majd a "load more" gombbal továbbiakat.

import React, { useEffect, useState } from 'react';
import { Box, Typography, Grid, Button, Paper } from '@mui/material';
import { fetchPaginatedExercises } from '../utils/fetchData';
import ExerciseCard from '../components/ExerciseCard';
import { Exercise } from '../utils/types';
import Loader from '../components/Loader';

const Exercises: React.FC = () => {
  // Lokális állapotok a komponens számára
  const [exercises, setExercises] = useState<Exercise[]>([]); // A gyakorlatok listájának tárolása
  const [error, setError] = useState<string | null>(null); // Hiba kezelése (főként ha nem érjük el az API-t)
  const [isLoading, setIsLoading] = useState<boolean>(false); // Betöltés állapota
  const [offset, setOffset] = useState<number>(0);  // Az oldal pozíciója, hogy melyik gyakorlatokat kell lekérni
  const exercisesPerPage = 10; // Az oldalankénti gyakorlatok száma

 // A komponens betöltésekor egyszer lefutó effektus
useEffect(() => {
  loadMoreExercises(); // Betöltjük az első gyakorlatokat
}, []); // Az üres tömb azt jelenti, hogy csak egyszer fut le

// Függvény a további gyakorlatok betöltéséhez
// Az async kulcsszóval ellátott függvényekben használhatjuk az await kulcsszót, amely megvárja egy Promise teljesülését, mielőtt folytatná a végrehajtást.
const loadMoreExercises = async () => {
  try {
    setIsLoading(true); // Betöltési állapot bekapcsolása
    const data: Exercise[] = await fetchPaginatedExercises(
      'https://exercisedb.p.rapidapi.com/exercises', // Az API végpont
      exercisesPerPage, // Az oldalanként betöltött elemek száma
      offset // Az aktuális oldal pozíciója
    );

    // Az új gyakorlatok hozzáadása a már meglévő listához
    setExercises((prevExercises) => [...prevExercises, ...data]);
    // Az új pozíció beállítása (lapozás)
    setOffset((prevOffset) => prevOffset + exercisesPerPage);
    // Ha nincs hiba, töröljük a hibát
    setError(null);
  } catch (error) {
    setError('Failed to load exercises');
    console.error('Error fetching exercises:', error);
  } finally {
    setIsLoading(false); // Betöltés befejezése
  }
};


  return (
    <Box sx={{ px: 3, py: 4, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      {/* Fejléc, ami a keresésre bátorít */}
      <Paper
        elevation={4}
        sx={{
          p: 2,
          backgroundColor: '#f0f4f8',
          borderRadius: 2,
          boxShadow: '0 3px 10px rgba(0, 0, 0, 0.2)',
          mb: 2,
          textAlign: 'center',
          width: '100%',
          maxWidth: 600,
        }}
      >
        <Typography
          sx={{
            fontWeight: 'bold', color: 'black', fontSize: '26px',
          }}
        >
          Search for your favorite exercises
        </Typography>
      </Paper>
      {/* Hiba kezelése */}
      {error ? (
        <Typography color="error">{error}</Typography> // Ha van hiba, kiírjuk
      ) : (
        <>
          <Grid container spacing={3}>
            {exercises.map((exercise) => (
              <Grid item xs={12} sm={6} md={4} lg={3} xl={2.4} key={exercise.id}>
                <ExerciseCard exercise={exercise} />
              </Grid>
            ))}
          </Grid>
          {/* Ha még töltődik az adat, akkor betöltési animáció */}
          {isLoading && <Loader />}  {/* Loader komponens, ha az adatok betöltődnek */}
          
          {/* Ha nem töltődik, akkor betöltés gomb */}
          {!isLoading && (
            <Box display="flex" justifyContent="center" mt={3}>
              <Button variant="contained" color="primary" onClick={loadMoreExercises}>
                Load More
              </Button>
            </Box>
          )}
        </>
      )}
    </Box>
  );
};

export default Exercises;
